import React, { FunctionComponent as FC } from 'react';
import './index.scss';
import { INSTITUTIONS } from '../TeaserPage/Institutions';

interface Author {
  name: string;
  affiliation: string;
}

const authors: Author[] = [
  { name: 'Yifang Wang', affiliation: 'Florida State University, Northwestern University' },
  { name: 'Rui Sheng', affiliation: 'Hong Kong University of Science and Technology' },
  { name: 'Erzhuo Shao', affiliation: 'Northwestern University' },
  { name: 'Yifan Qian', affiliation: 'Northwestern University' },
  { name: 'Haotian Li', affiliation: 'Hong Kong University of Science and Technology' },
  { name: 'Nan Cao', affiliation: 'Tongji University' },
  { name: 'Dashun Wang', affiliation: 'Northwestern University, Kellogg School of Management' },
];

interface AboutPageProps {
}

// Hidden for now, as in the design; remove `hidden` to show the team
const AboutPage: FC<AboutPageProps> = () => {
  return (
    <section className='teamx contain' id='team' hidden>
      <div className='tl'>
        <h2>Team</h2>
        <p>Visualization, HCI, and science-of-science researchers across four institutions.</p>
        <div className='tlogos' id='teamlogos'>
          {INSTITUTIONS.map((l) => <img key={l.alt} src={l.src} alt={l.alt} style={{ height: 48 }} />)}
        </div>
      </div>
      <div className='tr'>
        {authors.map((a) => (
          <div className='p' key={a.name}><b>{a.name}</b><span>{a.affiliation}</span></div>
        ))}
      </div>
    </section>
  )
}

export default AboutPage;
